<template>
  <tdhvp-doc-out-index-common
    :listFn="options => this.list(options)"
    @viewDetail="viewDetail"
  ></tdhvp-doc-out-index-common>
</template>

<script>
import { vbOutgoingDocTdhvpViewService } from "../../../services/tdhvp/vbOutgoingDocTdhvpViewService";
import TdhvpDocOutIndexCommon from "./tdhvp-doc-out-index-common";

export default {
  name: "tdhvp-doc-out-vt-index",
  components: {
    TdhvpDocOutIndexCommon
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  methods: {
    viewDetail({ item }) {
      this.$router.push({
        name: "tdhvpDocOutVtDetail",
        params: { id: item.id, userDeptRoleId: this.userDeptRoleId },
        query: this.$route.query
      });
    },

    list({ form, pageable }) {
      return vbOutgoingDocTdhvpViewService
        .findAllVbBanHanh(form, pageable)
        .then(response => response.data);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/doc-out/tdhvp-doc-out-vt-index.vue